import axios from 'axios';

import Config from '../../config';

import { PROJECT_FEEDBACK } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

export const api_delivery_milistone = (data) => {
    return (dispatch) => {

        return axios.put(`${Config.API_BASE_URL}/feedback/${data.projectId}/milestones/${data.milestoneId}/${data.prefix}/${data.flag}`, data).then(response => {

            const payload = {
                milestones: response.data,
                task: {
                    result: true
                }
            };

            dispatch({
                type: PROJECT_FEEDBACK,
                payload: payload
            })

            return payload;
        })
            .catch(error => {

                // Nao faz o dispatch no erro, tratamento direto na tela
                const payload = {
                    errors: error.response.data,
                    task: {
                        result: false
                    }
                };

                return payload;
            });
    };
}
export default api_delivery_milistone;
